import './App.css'
import Solver from './pages/Solver/solver';
function App() {
  return (
    <Solver />
  );
}

export default App;
